import {useContext, useEffect, useState} from 'react';
import {collection, onSnapshot, query} from 'firebase/firestore';
import {where} from '-/data/firestoreQuery';

import {db} from '-/firebase';
import {UserContext} from '-/contexts/User';

// The current member's own admin-hours timesheets (#1206). Members only ever see
// their own, so this is a cheap own-uid query (mirrors useAssignmentBadge).
//
// Returns {actionCount, timesheetCount}:
//   - actionCount   — sheets still waiting on them (draft/rejected); the badge.
//   - timesheetCount — sheets they're on at all. Drives whether the nav item
//     shows for a member who holds NEITHER payroll.submitHours nor payroll.write:
//     they can't create a sheet, but an officer can create one FOR them (#1376,
//     and more so with shared rosters in #1441), and they need to be able to open
//     what was logged in their name — the emails deep-link straight to it.
export default function useAdminHoursBadge() {
    const {currentUser} = useContext(UserContext);
    const [counts, setCounts] = useState({actionCount: 0, timesheetCount: 0});

    useEffect(() => {
        if (!currentUser?.uid || currentUser.isStation) {
            setCounts({actionCount: 0, timesheetCount: 0});
            return undefined;
        }
        // array-contains: a sheet can cover several members since #1441, and it's
        // actionable for every one of them.
        const q = query(collection(db, 'adminHoursTimesheets'), where('memberUids', 'array-contains', currentUser.uid));
        const unsub = onSnapshot(q, snap => {
            setCounts({
                actionCount: snap.docs.filter(d => ['draft', 'rejected'].includes(d.data().status)).length,
                timesheetCount: snap.size
            });
        }, err => {
            console.error('Error loading admin-hours badge:', err);
            setCounts({actionCount: 0, timesheetCount: 0});
        });
        return () => unsub();
    }, [currentUser?.uid, currentUser?.isStation]);

    return counts;
}
